import type {ReactElement} from 'react';
import {Modal} from '@Components/modal';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import {LazyPanel} from '@Components/lazy-panel';
import type {ConfirmRemoveVideoBackgroundPanelProps} from '@Panels/confirm-remove-video-background-panel/confirm-remove-video-background-panel';
import {useAppSelector} from '@/hooks';

const PANEL_ID = 'confirm-remove-video-background-panel';

export type ConfirmRemoveVideoBackgroundModalProps = ConfirmRemoveVideoBackgroundPanelProps;

export default function ConfirmRemoveVideoBackgroundModal(): ReactElement<any> {
  const modalData = useAppSelector((state) => {
    return state.modals.modalsHashmap[MODALS_IDS.CONFIRM_REMOVE_VIDEO_BACKGROUND_MODAL];
  });

  const height = '456px';
  const width = '540px';

  return (
    <Modal modalId={MODALS_IDS.CONFIRM_REMOVE_VIDEO_BACKGROUND_MODAL} panelId={PANEL_ID} modalHeight={height} modalWidth={width}>
      <LazyPanel
        panelDirectoryName="confirm-remove-video-background-panel"
        panelProps={{
          ...modalData.panelProps,
          panelId: PANEL_ID,
        }}
      />
    </Modal>
  );
}

export const openConfirmRemoveVideoBackgroundModal = (props: ConfirmRemoveVideoBackgroundModalProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.CONFIRM_REMOVE_VIDEO_BACKGROUND_MODAL,
      panelProps: props,
    })
  );
};
